import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=f61c2178&scoped=true&"
import script from "./Region.vue?vue&type=script&lang=ts&"
export * from "./Region.vue?vue&type=script&lang=ts&"
import style0 from "./Region.vue?vue&type=style&index=0&id=f61c2178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c2178",
  null
  
)

export default component.exports